
class RecordSearch{
    defaultOptions() {
        return {
            '$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onFilterChange = this.onFilterChange.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify("$container is missing in component/row/RecordSearch","error");
        }

        this.$form = $('.competition-record-form',this.$container);
        this.$filterDiscipline = $('select[name="discipline"]',this.$form);
        this.$filterBassin = $('select[name="bassin"]',this.$form);
        this.$filterCategorie = $('select[name="categorie"]',this.$form);
        this.$filterGenre = $('select[name="genre"]',this.$form);
        this.$filterType = $('select[name="type"]',this.$form);

        this.initialize();
    }


    initialize(){
        var self = this;

        this.$filterDiscipline.on('change',this.onFilterChange);
        this.$filterBassin.on('change',this.onFilterChange);
        this.$filterCategorie.on('change',this.onFilterChange);
        this.$filterGenre.on('change',this.onFilterChange);
        this.$filterType.on('change',this.onFilterChange);
        
    }

    onFilterChange(event){
        let $filter = $(event.target);

        this.$form.trigger('submit');
    }

}

module.exports = RecordSearch;